import { render, staticRenderFns } from "./CustomFieldsTable.vue?vue&type=template&id=42775d79&scoped=true"
import script from "./CustomFieldsTable.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldsTable.vue?vue&type=style&index=0&id=42775d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42775d79",
  null
  
)

export default component.exports